export function submissionSelectionKey(
  type: string,
  cityDay: string,
  time: string,
  location: string,
  place: string,
  zone: string,
): string {
  return JSON.stringify([type, cityDay, time, location, place, zone]);
}
